import { API_ENDPOINTS } from '../config';
import type { WaitlistSubmission, WaitlistResponse, WaitlistStats } from '../types';

export async function submitWaitlist(data: WaitlistSubmission): Promise<WaitlistResponse> {
    try {
        const response = await fetch(API_ENDPOINTS.WAITLIST_SUBMIT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to submit waitlist');
        }

        return await response.json();
    } catch (error) {
        console.error('Error submitting waitlist:', error);
        throw error;
    }
}

export async function getWaitlistStats(): Promise<WaitlistStats> {
    try {
        const response = await fetch(API_ENDPOINTS.WAITLIST_STATS);

        if (!response.ok) {
            throw new Error('Failed to fetch waitlist stats');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching waitlist stats:', error);
        return { count: 0 };
    }
}
